const encoder = new TextEncoder()

// HMAC-SHA256 of the subject under a deployment-specific pepper, as 64 lowercase hex
// characters. PostHog never receives the raw Keycloak subject, and without the pepper
// the pseudonym cannot be joined back to it.
export async function derivePseudonym(subject: string, pepper: string): Promise<string> {
  if (!subject) {
    throw new Error('derivePseudonym: subject must not be empty')
  }
  if (!pepper) {
    throw new Error('derivePseudonym: pepper must not be empty')
  }

  const key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(pepper),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  )
  const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(subject))

  return Array.from(new Uint8Array(signature), (byte) => byte.toString(16).padStart(2, '0')).join(
    ''
  )
}
